import { render, staticRenderFns } from "./allergies_intolerences.vue?vue&type=template&id=222ccc1a&"
import script from "./allergies_intolerences.vue?vue&type=script&lang=js&"
export * from "./allergies_intolerences.vue?vue&type=script&lang=js&"
import style0 from "./allergies_intolerences.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports